import { motion } from 'framer-motion';
import { Mail, Linkedin, MapPin, Download, Phone } from 'lucide-react';
import { personalData } from '../data/content';

export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gray-900 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Let's Connect</h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            I'm always open to discussing new opportunities in operations management, nonprofit leadership, and sustainability initiatives.
          </p>

          <div className="flex flex-col md:flex-row justify-center gap-8 mb-16">
            <a 
              href={`mailto:${personalData.contact.email}`}
              className="flex items-center justify-center gap-3 px-8 py-4 bg-emerald-600 hover:bg-emerald-700 rounded-lg transition-colors font-medium text-lg"
            >
              <Mail className="w-5 h-5" />
              Send an Email
            </a>
            <a 
              href={personalData.contact.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg transition-colors font-medium text-lg"
            >
              <Linkedin className="w-5 h-5" />
              LinkedIn Profile
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center border-t border-gray-800 pt-12">
            <div>
              <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 text-emerald-400">
                <MapPin className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Location</h3>
              <p className="text-gray-400 text-sm">{personalData.contact.location}</p>
            </div>
            <div>
              <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 text-emerald-400">
                <Mail className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Email</h3>
              <a 
                href={`mailto:${personalData.contact.email}`}
                className="text-gray-400 hover:text-emerald-400 transition-colors text-sm break-all"
              >
                {personalData.contact.email}
              </a>
            </div>
            <div>
              <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 text-emerald-400">
                <Phone className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Phone</h3>
              <a 
                href={`tel:${personalData.contact.phone.replace(/[^\d+]/g, '')}`}
                className="text-gray-400 hover:text-emerald-400 transition-colors text-sm"
              >
                {personalData.contact.phone}
              </a>
            </div>
            <div>
              <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 text-emerald-400">
                <Download className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Resume</h3>
              <a 
                href="/MitchBreyResume.pdf" 
                download="MitchBreyResume.pdf"
                className="text-emerald-400 hover:text-emerald-300 underline text-sm"
              >
                Download PDF
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
